import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import * as amplitude from '@amplitude/analytics-browser';

import { Button } from '@unified-checkout/design-system';
import {
  ArrowRight,
  CircleCheck,
  Xmark,
} from '@unified-checkout/design-system/icons/index';

import { getAccountDetails } from '@app/dashboard/services/inner_layout/bills/pay_ads/account-details';
import { INNER_ROUTES } from '@app/dashboard/constants/inner-routes';
import { notify } from '@app/dashboard/utils/notifier';

import { GOOGLE } from '@app/dashboard/constants/Bills';
import {
  BILLS_EVENTS,
  BILLS_EVENTS_PARAMS,
} from '@app/dashboard/constants/tracking_events/bills';

import GoogleAdsImg from '../../../assets/GoogleAds.png';
import PaymobArrow from '../../../assets/PaymobArrow.svg';

import styles from './ads-card.module.scss';

export const AdsCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { mutate: fetchAccountDetails, isPending: isAccountDetailsLoading } =
    useMutation({
      mutationFn: getAccountDetails,
      onSuccess: (data) => {
        const googleTapLink = data?.data?.data?.google_url;
        const isLinkedAccount = data?.data?.data?.account_linked;

        const width = 500;
        const height = 600;
        const left = (window.screen.width - width) / 2;
        const top = (window.screen.height - height) / 2;

        if (isLinkedAccount) {
          amplitude.track(BILLS_EVENTS.BILLS_PAY_ADS_NOW_SELECTED, {
            [BILLS_EVENTS_PARAMS.AD_PLATFORM]: GOOGLE,
            [BILLS_EVENTS_PARAMS.IS_FIRST_TIME]: false,
            [BILLS_EVENTS_PARAMS.AD_ACCOUNT_ID]: data?.data?.data?.account_details?.account_id,
          });
          navigate(INNER_ROUTES.PAY_ADS);
        } else {
          amplitude.track(BILLS_EVENTS.BILLS_CONNECT_AD_ACCOUNT_SELECTED, {
            [BILLS_EVENTS_PARAMS.AD_PLATFORM]: GOOGLE,
            [BILLS_EVENTS_PARAMS.IS_FIRST_TIME]: true,
          });
          window.open(
            googleTapLink,
            'GoogleWindow',
            `width=${width},height=${height},left=${left},top=${top}`
          );
        }
      },
      onError: (error: any) => {
        const errMsg =
          error?.response?.data?.message || t('errors.somethingWentWrong');
        notify.error(errMsg, { icon: Xmark });
      },
    });

  return (
    <div className={styles['ads-card']}>
      <div className={styles['ads-card__content']}>
        <div className={styles['ads-card__content__header']}>
          <div className={styles['ads-card__content__header__title']}>
            {t('innerLayout.billsPage.allServices.title')}
          </div>
          <div className={styles['ads-card__content__header__description']}>
            {t('innerLayout.billsPage.allServices.description')}
          </div>
        </div>

        <div className={styles['ads-card__content__body']}>
          <div className={styles['ads-card__content__body__text']}>
            {CircleCheck}
            {t('innerLayout.billsPage.allServices.zeroConversionFees')}
          </div>
          <div className={styles['ads-card__content__body__text']}>
            {CircleCheck}
            {t('innerLayout.billsPage.allServices.instantBalance')}
          </div>
        </div>

        <Button
          text={t('innerLayout.billsPage.allServices.fundNowButton')}
          trailingIcon={ArrowRight}
          loading={isAccountDetailsLoading}
          disabled={isAccountDetailsLoading}
          onClickHandler={() => fetchAccountDetails()}
        />
      </div>

      <div className={styles['ads-card__image']}>
        <img src={GoogleAdsImg} alt="GoogleAds" />
      </div>
      <img
        className={styles['ads-card__paymob-arrow']}
        src={PaymobArrow}
        alt="paymob-arrow"
      />
    </div>
  );
};
